<div class="mat-row">
    <div *ngIf="mostrarFormulario" class="container animate__animated animate__fadeIn ">
        <div>
            <div *ngIf="isAccepting" class="d-flex flex-column align-items-center">
                <h2>Aceptar Cotización</h2>
            </div>
            <div *ngElse class="d-flex flex-column align-items-center">
                <h2>Rechazar Cotización</h2>
            </div>
          
            <mat-dialog-content class="mat-typography">
                <div class="container-fluid mt-4">
                    <form [formGroup]="form">
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                <label id="example-radio-group-label">Seleccione una opción</label>
                                <mat-radio-group aria-label="Select an option" formControlName="opcionSeleccionada">
                                    <mat-radio-button class="example-radio-button" value="1">Aceptar Cotización</mat-radio-button>
                                    <mat-radio-button class="example-radio-button" value="0">Rechazar Cotización</mat-radio-button>
                                  </mat-radio-group>
                            </div>
                        </div>
                        <div class="row align-items-center">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                            <mat-form-field color="accent-darker" appearance="outline">
                                <mat-label>Comentario</mat-label>
                                <textarea #comentario matInput maxlength="4000" formControlName="comentarioLogAutorizacion"
                                type="text"></textarea>
                                <mat-hint align="start">Máximo: 4000 caracteres</mat-hint>
                                <mat-hint align="end">{{comentario.value?.length || 0}} / 4000</mat-hint>
                            </mat-form-field>
                            </div>
                        </div>
                    </form>
                    <mat-dialog-actions align="end">
                        <button (click)="onSubmit()" [disabled]="form.invalid" mat-flat-button color="accent">Aceptar</button>
                    </mat-dialog-actions>
                </div>
            </mat-dialog-content> 
        </div>   
    </div>
    
    <div class="home-div home-top">
        <div class="container-main-home">
            <div *ngIf="!mostrarFormulario" class="mensaje-agradecimiento">
                {{ mensajeAgradecimiento }}
            </div>   
        </div>
    </div>
</div>
<div class="home-bottom">
  <div class=" d-flex justify-content-center gap-2 mb-4 footer-home">
    <p class="p-ayuda">¿Necesitás Ayuda?</p>
    <a class="hyperlink-pie-home" href="mailto:{{Etiquetas.MailContacto}}">Contactate con nosotros</a>
  </div>
</div>
